export default __webpack_public_path__ + "static/media/finger2.7a1803dc.png";